import { auth } from '@/services/firebase';

const API_BASE = import.meta.env.VITE_API_BASE || 'shiftpal.martelman.com';
const USE_LOCAL_PROXY = import.meta.env.VITE_USE_LOCAL_PROXY === 'true';

function baseUrl(): string {
  if (USE_LOCAL_PROXY && import.meta.env.DEV) return '/api';
  return `https://${API_BASE}`;
}

export class ApiError extends Error {
  constructor(public status: number, public body: string) {
    super(`API ${status}: ${body}`);
  }
}

type PostOptions = {
  auth?: boolean;
  timeoutMs?: number;
};

export async function apiPost<T>(
  path: string,
  body: unknown,
  opts: PostOptions = {},
): Promise<T> {
  const { auth: needsAuth = true, timeoutMs = 20_000 } = opts;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (needsAuth) {
    const token = await auth.currentUser?.getIdToken();
    if (!token) throw new ApiError(401, 'no firebase id token');
    headers['Authorization'] = `Bearer ${token}`;
  }

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${baseUrl()}/${path.replace(/^\//, '')}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const text = await res.text();
    if (!res.ok) throw new ApiError(res.status, text);
    return text ? (JSON.parse(text) as T) : (undefined as T);
  } finally {
    clearTimeout(timer);
  }
}
